import {Configuration} from './Configuration';
import {ConnectBasicEntityExt} from '../../framework/message/ConnectBasicEntityExt';
import {CrossVision} from './CrossVision';
import {EngineExt} from '../../engineparam/message/EngineExt';
import {ProcessBase} from './ProcessBase';
import {ProcessExt} from './ProcessExt';
import {TranslatedEmb} from '../../../../allkey/locale/message/TranslatedEmb';

export class MetaProcess extends ConnectBasicEntityExt {
crossVisions: {[key: string]: CrossVision};
description: TranslatedEmb;
engines: {[key: string]: EngineExt};
label: TranslatedEmb;
params: Configuration;
process: ProcessBase[];
processExtList: ProcessExt[];
visionCode: string;
}

